<div id="dashboard-project" class="page-layout simple right-sidenav" fxLayout="row">

  <!-- CENTER -->
  <div class="center" fxFlex>

    <!-- HEADER -->
    <!-- <div class="header thin-header mat-accent-bg p-12 p-sm-24" fxLayout="column" fxLayoutAlign="space-between">

      <div fxFlex="" fxLayoutAlign="start center">
        <mat-icon class="logo-icon" *eguardIfOnDom>bar_chart</mat-icon>&nbsp;&nbsp;
        <span class="logo-text h1">Reports </span>
      </div>
    </div> -->
    <div class="content">
      <nav mat-tab-nav-bar>
        <a mat-tab-link (click)="selectedTab = 0" [active]="selectedTab == 0">Case Types </a>
        <a mat-tab-link (click)="selectedTab = 1" [active]="selectedTab == 1">Case Status </a>
        <!-- <a mat-tab-link (click)="selectedTab = 2" [active]="selectedTab == 2">Active Cases </a>
        <a mat-tab-link (click)="selectedTab = 3" [active]="selectedTab == 3">Paid Cases </a> -->
        <a mat-tab-link (click)="selectedTab = 4" [active]="selectedTab == 4">Annual Cases </a>
        <a mat-tab-link (click)="selectedTab = 5" [active]="selectedTab == 5">Case Age </a>
      </nav>
      <div class="p-12 tab-content" [class.show]="selectedTab == 0">
        <case-type-reports [userAttributes]="userAttributes"></case-type-reports>
      </div>
      <div class="p-12 tab-content" [class.show]="selectedTab == 1">
        <case-status-reports [userAttributes]="userAttributes"></case-status-reports>
      </div>
      <!-- <div class="p-12 tab-content" [class.show]="selectedTab == 2">
        <active-cases-reports [userAttributes]="userAttributes"></active-cases-reports>
      </div>
      <div class="p-12 tab-content" [class.show]="selectedTab == 3">
        <paid-cases [userAttributes]="userAttributes"></paid-cases>
      </div> -->
      <div class="p-12 tab-content" [class.show]="selectedTab == 4">
        <calendar-cases [userAttributes]="userAttributes"></calendar-cases>
      </div>
      <div class="p-12 tab-content" [class.show]="selectedTab == 5">
        <case-age [userAttributes]="userAttributes"></case-age>
      </div>

      <!-- <mat-tab-group dynamicHeight (selectedTabChange)="chartTabChange($event)">

        <mat-tab label="Case Types">
          <div class="p-12" ng-show="selectedTab == 0" >
            <case-type-reports [userAttributes]="userAttributes"></case-type-reports>
          </div>
        </mat-tab>

        <mat-tab label="Case Status">
          <div class="p-12" ng-show="selectedTab == 1">
            <case-status-reports [userAttributes]="userAttributes"></case-status-reports>
          </div>
        </mat-tab>

        <mat-tab label="Active Cases">
          <div class="p-12" ng-show="selectedTab == 2">
            <active-cases-reports [userAttributes]="userAttributes"></active-cases-reports>
          </div>
        </mat-tab>

        <mat-tab label="Paid Cases">
          <div class="p-12"ng-show="selectedTab == 3">
            <paid-cases [userAttributes]="userAttributes"></paid-cases>
          </div>
        </mat-tab>

        <mat-tab label="Calendar Cases">
          <div class="p-12" ng-show="selectedTab == 4">
            <calendar-cases [userAttributes]="userAttributes"></calendar-cases>
          </div>
        </mat-tab>

        <mat-tab label="Case Age">
          <div class="p-12" ng-show="selectedTab == 5">
            <case-age [userAttributes]="userAttributes"></case-age>
          </div>
        </mat-tab>

      </mat-tab-group> -->

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/reports/reports.component.html